"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuHeightStyle = exports.getVerticalPosition = exports.detectOrderOfComponents = exports.detectSelected = exports.isOptionSelected = exports.detectGroupIndeterminacy = exports.convertComponentsToArray = exports.formatOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _value = require("../../skybase-core/utils/value");

var _sbSelectGroup = require("./sb-select-group");

var _constants = require("../sb-dropdown/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatOptions = function formatOptions(_ref) {
  var items = _ref.items,
      searchValue = _ref.searchValue;

  if (!searchValue || !searchValue.length) {
    return items;
  }

  var result = items.filter(function (item) {
    var label = item.label,
        options = item.options,
        title = item.title;

    if (options === null || options === void 0 ? void 0 : options.length) {
      if (searchByLabelOrTitle({
        label: label,
        title: title,
        value: searchValue
      })) {
        return true;
      }

      var itemOptions = options.filter(function (subOption) {
        return searchByLabelOrTitle({
          label: subOption.label,
          title: subOption.title,
          value: searchValue
        });
      });

      if (itemOptions === null || itemOptions === void 0 ? void 0 : itemOptions.length) {
        return true;
      }
    }

    return searchByLabelOrTitle({
      label: label,
      title: title,
      value: searchValue
    });
  });
  return result.map(function (item) {
    var _item$options;

    if ((_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.length) {
      return _objectSpread(_objectSpread({}, item), {}, {
        options: item.options.filter(function (subOption) {
          return searchByLabelOrTitle({
            label: subOption.label,
            title: subOption.title,
            value: searchValue
          });
        })
      });
    }

    return item;
  });
};

exports.formatOptions = formatOptions;

var searchByLabelOrTitle = function searchByLabelOrTitle(_ref2) {
  var label = _ref2.label,
      title = _ref2.title,
      value = _ref2.value;
  return typeof label === 'string' && (label === null || label === void 0 ? void 0 : label.toLowerCase().indexOf(value)) !== -1 || title && title.toLowerCase().indexOf(value) !== -1;
}; // eslint-disable-next-line no-prototype-builtins


var isComponentSelectGroup = function isComponentSelectGroup(component) {
  return (component === null || component === void 0 ? void 0 : component.type) && (_sbSelectGroup.SbSelectGroup.isPrototypeOf(component.type) || component.type === _sbSelectGroup.SbSelectGroup);
};

var convertComponentsToArray = function convertComponentsToArray(components) {
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var result = [];
  components.forEach(function (item) {
    var _item$props = item.props,
        children = _item$props.children,
        onClick = _item$props.onClick,
        rest = _objectWithoutProperties(_item$props, ["children", "onClick"]);

    var reactChildren = _react.default.Children.toArray(children);

    if (recursive && isComponentSelectGroup(item)) {
      result.push(_objectSpread(_objectSpread({}, rest), {}, {
        options: convertComponentsToArray(reactChildren, false)
      }));
    } else {
      result.push(_objectSpread(_objectSpread({}, rest), {}, {
        label: children
      }));
    }
  });
  return result;
};

exports.convertComponentsToArray = convertComponentsToArray;

var detectGroupIndeterminacy = function detectGroupIndeterminacy(_ref3) {
  var options = _ref3.options,
      selected = _ref3.selected;

  if (!options || !options.length || !selected || !selected.length) {
    return {
      indeterminate: false,
      allSelected: false
    };
  }

  var selectedCount = options.reduce(function (acc, option) {
    return (isOptionSelected({
      selected: selected,
      option: option
    }) ? 1 : 0) + acc;
  }, 0);
  return {
    indeterminate: selectedCount > 0 && selectedCount < options.length,
    allSelected: selectedCount === options.length
  };
};

exports.detectGroupIndeterminacy = detectGroupIndeterminacy;

var isOptionSelected = function isOptionSelected(_ref4) {
  var selected = _ref4.selected,
      option = _ref4.option;

  if (!selected || !option) {
    return false;
  }

  if (Array.isArray(selected)) {
    return selected.findIndex(function (sel) {
      var _option$props;

      return ((_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.value) === sel || option.value === sel;
    }) !== -1;
  }

  return option.props ? option.props.value === selected : option.value === selected;
};

exports.isOptionSelected = isOptionSelected;

var detectSelected = function detectSelected(_ref5) {
  var selected = _ref5.selected,
      value = _ref5.value,
      order = _ref5.order,
      newValue = _ref5.newValue;

  if (!selected || !selected.length) {
    return Array.isArray(value) ? value : [value];
  }

  var newSelected = _toConsumableArray(Array.isArray(selected) ? selected : [selected]);

  if (!Array.isArray(value)) {
    var index = newSelected.indexOf(value);

    if (index !== -1) {
      newSelected.splice(index, 1);
    } else {
      newSelected.push(value);
    }
  } else {
    value.forEach(function (val) {
      if (newSelected.indexOf(val) === -1 && newValue) {
        newSelected.push(val);
      } else if (newSelected.indexOf(val) !== -1 && !newValue) {
        newSelected.splice(newSelected.indexOf(val), 1);
      }
    });
  }

  return sortSelected({
    selected: newSelected,
    order: order
  });
};

exports.detectSelected = detectSelected;

var sortSelected = function sortSelected(_ref6) {
  var selected = _ref6.selected,
      order = _ref6.order;

  if (!order) {
    return selected;
  }

  var result = [];
  selected.forEach(function (item) {
    var i = 0;

    while (i < result.length) {
      if (order.indexOf(result[i]) >= item) {
        break;
      }

      i += 1;
    }

    result.splice(i, 0, item);
  });
  return result;
};

var detectOrderOfComponents = function detectOrderOfComponents(items) {
  var _items$0$props;

  if (!items || !items.length) {
    return [];
  }

  var structure = ((_items$0$props = items[0].props) === null || _items$0$props === void 0 ? void 0 : _items$0$props.children) ? convertComponentsToArray(items) : _toConsumableArray(items);

  if (!structure || !structure.length) {
    return [];
  }

  var result = [];

  while (structure.length) {
    var item = structure.shift();

    if (item.value) {
      result.push(item.value);
    }

    if (item.options && item.options.length) {
      structure = (0, _merge.default)(item.options, structure);
    }
  }

  return result;
};

exports.detectOrderOfComponents = detectOrderOfComponents;

var getVerticalPosition = function getVerticalPosition(menuPosition) {
  if (!menuPosition) {
    return null;
  }

  var TOP = _constants.menuPositions.TOP,
      TOP_LEFT = _constants.menuPositions.TOP_LEFT,
      TOP_RIGHT = _constants.menuPositions.TOP_RIGHT,
      BOTTOM = _constants.menuPositions.BOTTOM,
      BOTTOM_LEFT = _constants.menuPositions.BOTTOM_LEFT,
      BOTTOM_RIGHT = _constants.menuPositions.BOTTOM_RIGHT;

  if (menuPosition.indexOf(TOP_RIGHT) !== -1 || menuPosition.indexOf(TOP_LEFT) !== -1) {
    return TOP;
  }

  if (menuPosition.indexOf(BOTTOM_RIGHT) !== -1 || menuPosition.indexOf(BOTTOM_LEFT) !== -1) {
    return BOTTOM;
  }

  return null;
};

exports.getVerticalPosition = getVerticalPosition;

var getHeightStyle = function getHeightStyle(_ref7) {
  var heightProp = _ref7.heightProp,
      heightPropValue = _ref7.heightPropValue,
      liveSearchHeight = _ref7.liveSearchHeight;
  var heightStyle = {};

  if (!(0, _value.isNullOrUndefined)(heightPropValue)) {
    if (typeof heightPropValue === 'number') {
      heightStyle = _defineProperty({}, heightProp, "".concat(heightPropValue - liveSearchHeight, "px"));
    } else if (heightPropValue.indexOf('px') !== -1) {
      // if user puts '150px', which is valid css value, then `parseInt` translates it as `150`
      // any other usage (which parseInt would fail) like 'px150' is not css correct.
      heightStyle = _defineProperty({}, heightProp, "".concat(parseInt(heightPropValue, 10) - liveSearchHeight, "px"));
    } else {
      heightStyle = _defineProperty({}, heightProp, "calc(".concat(heightPropValue, "-").concat(liveSearchHeight, "px)"));
    }
  }

  return heightStyle;
};

var getMenuHeightStyle = function getMenuHeightStyle(_ref8) {
  var maxHeight = _ref8.maxHeight,
      minHeight = _ref8.minHeight,
      height = _ref8.height,
      liveSearch = _ref8.liveSearch;
  var liveSearchHeight = liveSearch ? 30 : 0;
  return Object.assign({}, {
    overflowY: 'auto'
  }, getHeightStyle({
    heightProp: 'maxHeight',
    heightPropValue: maxHeight,
    liveSearchHeight: liveSearchHeight
  }), getHeightStyle({
    heightProp: 'minHeight',
    heightPropValue: minHeight,
    liveSearchHeight: liveSearchHeight
  }), getHeightStyle({
    heightProp: 'height',
    heightPropValue: height,
    liveSearchHeight: liveSearchHeight
  }));
};

exports.getMenuHeightStyle = getMenuHeightStyle;
//# sourceMappingURL=utils.js.map